<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-3"></div>
            <div class="col-md-6">
              <div class="form-group">
                <input type="text" autofocus class="form-control" v-model="search" @input="(val) => searchChange(val)"
                  :placeholder="$t(`site.search`)" />
              </div>
            </div>
            <div class="col-3">
              <div class="float-md-right pt-1">
                <span class="text-muted text-small mr-1 mb-2">
                  {{ from }}:{{ to }}
                </span>

                <b-dropdown id="ddown2" right :text="`${perPage}`" variant="outline-warning" size="xs">
                  <b-dropdown-item v-for="(size, index) in [5, 10, 20, 50, 100]" :key="index"
                    @click="changePageSize(size)">{{ size }}</b-dropdown-item>
                </b-dropdown>
                <span class="text-muted mr-1 mb-2"> of {{ total }}</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <b-dropdown v-if="$role == 'super_admin' || $role == 'QuranAdmin'" :text="$t('quran_programs.teachers')"
                variant="flat-primary">
                <!--Teachers dropdown-->
                <b-dropdown-item v-for="teacher in teachers" @click="filterTeachers(teacher.id)">
                  {{ teacher.name }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 overflow-auto">
              <b-card>
                <b-table :stacked="$mobile == 1" responsive ref="table" class="vuetable" sort-by="id"
                  sort-desc.sync="false" :current-page="currentPage" :fields="bootstrapTable.fields"
                  :items="dataProvider" style="min-height: 250px">
                  <template #cell(checkbox)="data">
                    <label class="kt-checkbox kt-checkbox--single kt-checkbox--solid">
                      <input type="checkbox" v-model="recordIds" :value="data.item.id" @change="selectItem(data)" />
                      <span></span>
                    </label>
                  </template>
                  <template #cell(teacher_full_name)="data">
                    {{ (data.item.teacher ? data.item.teacher.first_name : '') + " " + (data.item.teacher ?
                      data.item.teacher.last_name : '') }}
                  </template>
                      <template #cell(join_live)="row">
                    <div class="text-center">
                        <button v-if="row.item.online_session && row.item.online_session.id"
                            @click="openLive(row.item.online_session)" class="btn btn-primary btn-sm">
                            <i class="fas fa-video"></i> انضم للجلسة المباشرة
                        </button>
                        <button v-else class="btn btn-secondary btn-sm" disabled>
                            <i class="fas fa-video"></i> لا يوجد جلسة مباشرة
                        </button>
                    </div>
                </template>


                  <!-- <template #cell(teacher_full_name)="data">
                      <b-badge variant="light-info">
                        {{ data.item.quran_program.quran_program.title }}
                      </b-badge>
                    </template> -->
                  <!-- <template #cell(date)="data">
                      <b-badge>
                        {{ data.item.quran_program.date }}
                      </b-badge>
                    </template> -->

                  <!-- <template #cell(starts_in)="data">
                      <b-badge variant="light-success">
                        {{ data.item.quran_program.start }}
                      </b-badge>
                    </template>
  
                    <template #cell(ends_in)="data">
                      <b-badge variant="light-success">
                        {{ data.item.quran_program.end }}
                      </b-badge>
                    </template> -->
                  <!-- <template #cell(teachers)="data">
                      <b-badge
                        variant="light-primary"
                        v-if="data.item.quran_program.teachers.length > 0"
                      >
                        {{ data.item.quran_program.teachers[0].full_name }}
                      </b-badge>
                    </template> -->
                </b-table>
                <b-spinner v-if="load" type="grow" label="Loading..." class="loading" />
              </b-card>
            </div>
            <!-- end of col -->
          </div>

          <hr />
          <b-pagination size="sm" class="dataTables_paginate paging_simple_numbers pagination-warning"
            :total-rows="totalRows" :per-page="perPage" v-model="currentPage">
            <template v-slot:next-text>
              <i class="fas fa-angle-left" />
            </template>
            <template v-slot:prev-text>
              <i class="fas fa-angle-right" />
            </template>
            <template v-slot:first-text>
              <i class="fas fa-step-forward" />
            </template>
            <template v-slot:last-text>
              <i class="fas fa-step-backward" />
            </template>
          </b-pagination>
          <!-- end of row -->
          <b-modal id="modal-info" ok-variant="info" ok-title="save" modal-class="modal-info" centered size="lg"
            :title="title">
            <b-table :stacked="$mobile == 1" :items="users" :fields="userfields">
              <template #cell(checkbox)="data">
                <b-form-checkbox v-model="usersSelelcted" :value="data.item.id">
                </b-form-checkbox>
              </template>
            </b-table>

            <!-- <b-spinner v-else type="grow" label="Loading..."  class="loading" /> -->
          </b-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Auth from "@/Apis/Auth";
import controller from "@/Controllers/QuranProgramsController";
import QuranScheduleDateUser from "@/Controllers/QuranScheduleDateUserController";
import UsersController from "@/Controllers/UsersController";
import flatPickr from "vue-flatpickr-component";
import OnlineSessionController from "@/Controllers/OnlineSessionController";

export default {
  name: "QuranProgramsDataTable",
  components: {
    flatPickr,
  },
  data() {
    return {
      teachers_list: [],
      dateNtim: null,
      schedules: [],
      itemView: "DataTable",
      controller: new QuranScheduleDateUser(),
      title: "",
      newDate: {},
      draft: 1,
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [
          {
            key: "program.title",
            label: "المقرأة",
            sortable: false,
          },
          {
            key: "schedule.name",
            label: "الورد",
            sortable: false,
          },
          {
            key: "date",
            label: "التاريخ",
            sortable: false,
          },
          {
            key: "schedule.start",
            label: "تبدأ في",
            sortable: false,
          },
          {
            key: "schedule.end",
            label: "تنتهي في",
            sortable: false,
          },

          {
            key: "join_live",
            label: "الانضمام للجلسة المباشرة",
            sortable: false,
          }

        ],
      },
      data: [],
      teachers: [],
      selectAll: false,
      currentPage: 1,
      select: [],
      page: 1,
      perPage: 15,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,

      recordIds: [],
      users: {},
      userfields: [
        { key: "checkbox", label: "", sortable: false },
        {
          key: "code",
          label: this.$i18n.t("students.academic_number"),
          sortable: true,
        },
        {
          key: "student.first_name",
          label: this.$i18n.t("students.first_name"),
          sortable: true,
        },
        {
          key: "student.last_name",
          label: this.$i18n.t("students.last_name"),
          sortable: true,
        },
        {
          key: "student.email",
          label: this.$i18n.t("users.email"),
          sortable: true,
        },
      ],
      programSelelcted: {},
      teacherFilter: null,
    };
  },
  async created() {
    if (Auth.USER.account_type == "teacher") {
      this.teacherFilter = `teacher_id|${Auth.USER.id}`;
    } else {
      this.userfields.push({
        key: "teacher_full_name",
        label: this.$t("teachers.full_name"),
        sortable: false,
      });
      this.teachers = await this.controller.GetTeachersOptions();
    }
    const itemViewOptions = [
      { icon: "GridIcon", value: "grid-view" },
      { icon: "ListIcon", value: "list-view" },
    ];
  },
  methods: {
    refresh() {
      this.$refs.table.refresh();
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    filterTeachers(id) {
      this.teacherFilter = `teacher_id|${id}`;
      this.params.filter = this.teacherFilter;
      this.$refs.table.refresh();
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    async dataProvider(ctx) {
      this.load = true;
      this.params = ctx;
      if (this.teacherFilter) {
        this.params.filter = this.teacherFilter;
      }
      const data = await this.controller.GetTeacherSchedules(this.apiParamsConverter());
      this.currentPage = data.current_page;
      this.perPage = data.per_page;
      this.totalRows = data.total;
      this.from = data.from;
      this.to = data.to;
      this.total = data.total;
      this.data =
        data.data.sort((a, b) => {
          return new Date(a.date) - new Date(b.date);
        }); 
      this.load = false;
      return data.data;
    },
    apiParamsConverter() {
      let apiParams = { per_page: this.perPage };
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }
      apiParams.sort = `id|desc`;

      if (this.params.filter && this.params.filter.length > 0) {
        apiParams.filter = this.params.filter;
      }
      if (this.search !== "") {
        apiParams.custom_search = this.search;
      }
      if (this.params.with && this.params.with.length > 0) {
        apiParams.with = this.params.with;
      }
      apiParams.with = ['onlineSession'];
      return apiParams;
    },
    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      this.$refs.table.refresh();
    },
     openLive(online_session) {
            new OnlineSessionController().joinLecture(online_session.id);
        },
  },
};
</script>
<style lang="scss">
@import "@core/scss/base/pages/app-ecommerce.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss" scoped>
.item-view-radio-group ::v-deep {
  .btn {
    display: flex;
    align-items: center;
  }
}
</style>